<template>
  <mt-button
    @click="$emit('click')"
    class="next-button"
    type="primary"
    size="large"
    :disabled="disabled">
    <slot></slot>
  </mt-button>
</template>

<script>
export default {
  name: 'NextButton',
  props: {
    disabled: Boolean,
  },
}
</script>

<style lang="stylus" scoped>

[data-theme='default'] .next-button
  background-color $theme-color
[data-theme='vip'] .next-button
  background-color $theme-color-vip

.next-button
  position absolute
  width 676px
  height 108px
  left 38px
  right 38px
  bottom 120px
  font-size 40px
  font-family 'PingFangSC-Semibold'
  user-select none
  &[disabled]
    background-color $dark-text-color

</style>
